// extracted by mini-css-extract-plugin
module.exports = {"blobs":"blobs_blobs__ysXY0"};